/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react'
import { FormattedMessage } from 'react-intl';

import { GroupThemedContentPanelWithFullHeader } from 'components/common/ContentPanel';
import { EmailInput } from 'components/common/TextInput';
import Form from 'components/common/Form';
import { CancelSubmitFormControls } from '../../../common/FormControls/CancelUpdateFormControls';
import { WhiteCardWithWidePadding } from 'components/common/Card/Card';
import { LocalText } from "../../common/LocalText";

class ForgotPasswordView extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      email: this.props.email,
    };
  }

  render() {
    return (
      <GroupThemedContentPanelWithFullHeader isFixedWidth titlePhrase={{ id: 'forgotPwd.title.text' }} subTitle={<LocalText text={this.props.organizationName}/>}>
        <WhiteCardWithWidePadding>
          <Form>
            <EmailInput
              value={this.state.email}
              onChange={(email) => { this.setState({ email }); }}
              label={<FormattedMessage id="forgotPwd.email.field.label" />}
            />

            <CancelSubmitFormControls
              onCancel={this.props.goBack}
              onSubmit={() => { this.props.submitEmail(this.state.email); }}
              isSubmitDisabled={false}
            />
          </Form>
        </WhiteCardWithWidePadding>
      </GroupThemedContentPanelWithFullHeader>
    );
  }
}

export default ForgotPasswordView;